import React from "react";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import * as Styles from "../../styles";

interface Props {
  date: string;
}

export const DateCell: React.FC<Props> = ({ date }) => {
  const formatted = moment(new Date(date)).format("DD/MM/YY");

  return (
    <Tooltip followCursor title={formatted || "--"} placement="top-start" arrow>
      <Styles.Td style={{ textAlign: "center" }}>{formatted || "--"}</Styles.Td>
    </Tooltip>
  );
};
